import { Type } from "@angular/core";
import { ItemOrdersChartComponent, ItemsByClassChartComponent, ItemsByProjectChartComponent, TopUsedItemsChartComponent } from './components';

export * from './components';
export * from './provider';
export * from './services';

export const IN_CHART_COMPONENTS: Record<string, Type<unknown>> = {
    "Inventory.ItemsByClassChart": ItemsByClassChartComponent,
    "Inventory.ItemsByProjectChart": ItemsByProjectChartComponent,
    "Inventory.TopUsedItemsChart": TopUsedItemsChartComponent,
    "Inventory.ItemOrdersChart": ItemOrdersChartComponent,
};
